module.exports = __webpack_public_path__ + "img/L1.aa9b4ec3.jpg";